
  var _styles = {
  "bounty-task": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center",
    "marginTop": "0.32rem"
  },
  "bounty-task-container": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "9.36rem",
    "height": "2.92rem",
    "padding": "0.32rem",
    "borderRadius": "0.32rem",
    "backgroundColor": "rgb(255,255,255)"
  },
  "bounty-task-content": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "bounty-task-title-wrap": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "bounty-task-text-icon": {
    "width": "0.57333rem",
    "height": "0.57333rem",
    "marginRight": "0.08rem"
  },
  "bounty-task-text": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.42667rem",
    "lineHeight": "0.58667rem"
  },
  "bounty-subtitle": {
    "fontWeight": "400",
    "color": "rgb(136,136,136)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "lineHeight": "0.42667rem",
    "marginTop": "0.08rem"
  },
  "bounty-task-buttons": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "100%",
    "marginTop": "0.28rem"
  },
  "bounty-task-button-wrapper": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "4.2rem",
    "height": "0.90667rem"
  },
  "bounty-task-button-image": {
    "width": "100%",
    "height": "100%"
  }
};



  module.exports = _styles;
  